import React from "react";

export default function WelcomeModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  const steps = [
    {
      emoji: "💝",
      title: "In or Out",
      description: "Swipe through thousands of names Tinder-style. Trust your gut and build your favorites list!"
    },
    {
      emoji: "⚔️",
      title: "Head to Head",
      description: "Battle your favorites against each other to discover your true top picks using our smart ranking system."
    },
    {
      emoji: "🤝",
      title: "Compare",
      description: "Find names you and your partner both love by comparing your lists and discovering shared favorites."
    },
    {
      emoji: "🔥",
      title: "Hot Takes",
      description: "Get honest feedback from friends and family on your top names. Share the love (or the roasts)!"
    }
  ];

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="welcome-modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>🎉 Welcome to Baby Names!</h2>
          <p>
            Your journey to finding the perfect name starts here. Here's how it
            works:
          </p>
          <button className="modal-close" onClick={onClose} aria-label="Close modal">
            ×
          </button>
        </div>

        <div className="modal-steps">
          {steps.map((step, index) => (
            <div key={index} className="step-card">
              <div className="step-number">{index + 1}</div>
              <div className="step-emoji">{step.emoji}</div>
              <div className="step-content">
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
              <div className="step-icon">{step.emoji}</div>
            </div>
          ))}
        </div>

        <div className="modal-footer">
          <button className="btn-primary modal-start-btn" onClick={onClose}>
            🚀 Start My Journey
          </button>
        </div>
      </div>
    </div>
  );
}
